export const statusColor = {
    "CONFIRMED": "#87C45E",
    "UNCONFIRMED": "#F7B526",
    "REWORK": "#3DB0DE",
    "RESUB": "#9747FF",
    "VERIFIED": "#004752"
}